import { faCalendarCheck, faCircleDollar, faDoNotEnter, faHourglass, faSquareDollar } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Space } from "antd"
import { PricingType, pricingTypeName, PricingTypes } from "../../common/constants"

type Props = {
  pricingType: PricingType
}

const icons = {
  [PricingTypes.QuotedPrice]: faCircleDollar,
  [PricingTypes.TimeAndMaterials]: faHourglass,
  [PricingTypes.FlatRate]: faSquareDollar,
  [PricingTypes.Unbillable]: faDoNotEnter,
  [PricingTypes.PerVisit]: faCalendarCheck
}

const PricingTypeDisplay = ({ pricingType }: Props) => {
  return <Space>
    <FontAwesomeIcon icon={icons[pricingType]} />
    {pricingTypeName(pricingType)}
  </Space>
}

export default PricingTypeDisplay
